<div class="icon-list">
    <span class="icon-frame" *ngFor="let keyword of keywords">
        <span *ngIf="keyword.name && keyword.code !== 'ado'" [class]="keyword.icon" [matTooltip]="keyword.name" matTooltipClass="matTooltip"></span>

        <mat-icon  *ngIf="keyword.code==='ado'">wc</mat-icon>
    </span>
</div>
